<template>
  <div class="set-password">
    <div class="tabbar"><span class="iconfont" @click="handleGo()">{{'\ue682'}}</span></div>
    <div class="title">设置密码</div>
    <div class="phone">
      请为手机号 {{setPhone(this.phone)}} 账号设置密码
    </div>
    <div class="form">
      <FormList
        :list="formList"
        :data="formData"
        :onChange="onInputChange"
      />
      <FieldRightButton :list="formListBtn" :data="formData" @onChange="onInputChange" :show='getPassword'></FieldRightButton>
    </div>
    <div :class="['next-step',getFormData ? '' : 'disabled-button']" @click="getFormData ? handleClick() : handleClick() ">
        下一步
      </div>
  </div>
</template>
<script>
import FormList from '@components/FormList'
import { Notify } from 'vant'
import { localStorage, aesDoEncrypt } from '@utils/basicUtil'
import FieldRightButton from '@components/FieldRightButton'
import { ukeyBoxRequest, accountRequest } from '@services'
export default {
  data () {
    return {
      phone: '',
      show: '',
      disabled: false,
      formData: {
        userName: '',
        password: '',
        okPassword: '',
        phone: '',
        name: '',
        loginType: '1',
        account: '',
        companyBOS: []
      },
      formListBtn: [
        {
          type: 'password',
          field: 'okPassword',
          placeholder: '请确认密码',
          label: '确认密码'
        }
      ],
      formList: [
        {
          type: 'text',
          field: 'userName',
          label: '姓名',
          placeholder: '请输入姓名',
          maxlength: 50
        },
        {
          type: 'password',
          field: 'password',
          placeholder: '请输入6~12位密码',
          label: '设定密码'
        }
      ]
    }
  },
  computed: {
    setPhone () {
      return function (phone) {
        return phone.substr(0, 3) + '****' + phone.substr(7)
      }
    },
    getFormData () {
      return this.formData.userName === '' || this.formData.password === '' || this.formData.okPassword === '' ? '' : this.formData.password === this.formData.okPassword ? '1' : ''
    },
    getPassword () {
      if (this.formData.password === '' || this.formData.okPassword === '') {
        return '2'
      }
      return this.formData.password === this.formData.okPassword ? '1' : ''
    }
  },
  mounted () {
    if (sessionStorage.ukeyBox) {
      let ukeyBox = JSON.parse(sessionStorage.ukeyBox)
      this.phone = ukeyBox.phone
    }
  },
  methods: {
    handleGo () {
      this.$router.go(-1)
    },
    async changeCurrentCompany (company) {
      if (!company) { return }
      const data = await accountRequest.company.changeCurrentCompany({ companyId: company.id })
      const detailData = await accountRequest.company.getCompanyDetail({}, { id: company.id })
      if (data.success) {
        localStorage.set('X-C-Token', data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      if (detailData.success && detailData.result) {
        const resCompany = detailData.result
        localStorage.set('companyId', resCompany.id)
        localStorage.set('companyName', resCompany.name)
        localStorage.set('invoiceLimits', resCompany.companyInfoResponse.invoiceType ? resCompany.companyInfoResponse.invoiceType.split(',').sort((a, b) => a - b).join(',') : '')
        localStorage.set('showTaxSign', resCompany.companyInfoResponse.showTaxSign)
        this.$store.commit('user/changeCompany', resCompany)
      } else {
        Notify({ type: 'danger', message: detailData.message })
      }
    },
    async getCompanies () {
      const postData = {
        size: 1
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        const defaultCompany = data.result.currentCompany ? data.result.currentCompany : data.result.records[0]
        if (!defaultCompany) {
          Notify({ type: 'danger', message: '您的账号没有关联公司，请联系业务人员操作' })
        }
        this.changeCurrentCompany(defaultCompany)
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    async handleClick () {
      if (this.formData.userName === '') {
        return Notify({ type: 'danger', message: '请先输入姓名' })
      }
      if (this.formData.password.length < 6 || this.formData.password.length > 12) {
        return Notify({ type: 'danger', message: '密码长度为6~12位' })
      }
      if (this.formData.password !== this.formData.okPassword) {
        return Notify({ type: 'danger', message: '两次密码输入不一致，请重新输入' })
      }
      let newPhone = this.phone
      this.formData.phone = newPhone
      this.formData.name = newPhone
      this.formData.account = newPhone
      // 此处调接口，将密码存储
      console.log(this.formData)
      let data = await ukeyBoxRequest.ukeyBox.addUser({ ...this.formData })
      if (data.success) {
        // 成功了就跳转到绑定终端页面
        this.formData.password = aesDoEncrypt(this.formData.password, true)
        this.formData.okPassword = aesDoEncrypt(this.formData.okPassword, true)
        const data = await accountRequest.login.login(this.formData)
        if (data.success) {
          Notify({ type: 'success', message: '登录成功' })
          localStorage.set('X-Access-Token', data.result)
          this.getCompanies()
          setTimeout(() => {
            this.$router.push({ path: '/ukey/binding' })
          }, 1000)
        } else {
          Notify({ type: 'danger', message: data.message })
        }
      } else {
        return Notify({ type: 'danger', message: data.message })
      }
    },
    onInputChange ({ e, field }) {
      this.formData[field] = e
    }
  },
  components: {
    FormList,
    FieldRightButton
  }
}
</script>
<style scoped lang="less" src="./style.less">

</style>
